import React, { useState } from 'react';

import { Stack, Text, useMantineTheme } from '@mantine/core';
import { IconChevronDown, IconClockHour4, IconInfinity, IconPlus } from '@tabler/icons-react';
import ButtonMenu from 'components/ButtonMenu';
import { DemoGymList } from 'types/generated';

import CreateDemoGymModal from './CreateDemoGymModal';

const CreateDemoGymButtonMenu = (): JSX.Element => {
  const theme = useMantineTheme();

  const [demoGymTypeToCreate, setDemoGymTypeToCreate] = useState<null | DemoGymList['type']>(null);

  return (
    <>
      <ButtonMenu
        title='New Demo Gym'
        leftIcon={<IconPlus size={theme.fontSizes.md} strokeWidth={3} />}
        rightIcon={<IconChevronDown size={theme.fontSizes.md} strokeWidth={3} />}
        size='sm'
        items={[
          {
            icon: <IconClockHour4 color={theme.colors.kiloBlue[5]} size={24} />,
            label: (
              <Stack spacing={0}>
                <Text fw={500}>Time-limited Demo</Text>
                <Text color='gray'>For prospects. Expires in 48h</Text>
              </Stack>
            ),
            onClick: () => {
              setDemoGymTypeToCreate('TIME_LIMITED');
            },
          },
          {
            icon: <IconInfinity color={theme.colors.grape[8]} size={24} />,
            label: (
              <Stack spacing={0}>
                <Text fw={500}>Persistent Demo</Text>
                <Text color='gray'>For prospects. With no time limit</Text>
              </Stack>
            ),
            onClick: () => {
              setDemoGymTypeToCreate('PERSISTENT');
            },
          },
        ]}
      />

      {demoGymTypeToCreate && (
        <CreateDemoGymModal
          opened={!!demoGymTypeToCreate}
          handleClose={() => setDemoGymTypeToCreate(null)}
          demoGymTypeToCreate={demoGymTypeToCreate}
        />
      )}
    </>
  );
};

export default CreateDemoGymButtonMenu;
